export enum UserRoles {
    CUSTOMER = 'Customer',
    REFERRAL = 'Referral'
}